const notices = {
  state: {
    notices: [],
    notice: {}
  },
  getters: {
    notices(state) {
      return state.notices;
    },
    notice(state) {
      return state.notice;
    }
  },
  mutations: {
    SET_NOTICES_LIST(state, payload) {
      state.notices = payload;
    },
    SET_NOTICE(state, payload) {
      state.notice = payload;
    }
  },
  actions: {
    async setNotice({ commit }, payload) {
      commit("SET_NOTICE", payload);
    }
  }
};

export default notices;



// WEBPACK FOOTER //
// ./src/vuex/setting/notices.js